import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { useWindowManager } from 'modules/desktop/pages/MainPage/components/WindowManager/hooks/useWindowManager'

import { WidgetComponent } from '../../types/widgets.types'
import { WidgetWrapper } from '../WidgetWrapper'

export const TasksWidget: WidgetComponent = ({ ...widgetProps }) => {
  const { openAppWindow } = useWindowManager()

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TASKMANAGEMENT_APP_V2_DEV_PATH,
    'task_management',
    './TaskManagementAppComponents',
    'taskManagementAppV2'
  )

  const { apps } = useAvailableApps()

  const handleTaskClick = (taskId: number, boardId: number) => {
    openAppWindow(
      AppId.TASK_MANAGEMENT,
      `${apps[AppId.TASK_MANAGEMENT].path}/boards/${boardId}/tasks/${taskId}`
    )
  }

  // @ts-expect-error: dynamic import
  const { TasksListingWidget } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { TasksListingWidget: () => <></> }

  return (
    <WidgetWrapper {...widgetProps} hasFullView isLoading={!isLoaded}>
      <TasksListingWidget
        showFullView={widgetProps.isInFullView}
        handleTaskClick={handleTaskClick}
      />
    </WidgetWrapper>
  )
}
